export default "__VITE_ASSET__WHxy3HmR__"